import React from 'react';

// Styles & Assets
import styles from './TableCell.module.css';

// Interface
import { HasID } from '../../../../interfaces/UtilInterfaces';
import { Column } from '../../../../interfaces/Columns';
interface Props<T> {
    col: Column<T>,
    row: T,
    active: boolean
    handleClick: (e: React.MouseEvent<HTMLElement>) => void
}

export const TableCell = <T extends HasID>({ col, row, active, handleClick }: Props<T>) => {

    return (
        <td
            className={`${col.classBody} ${styles.cellTable}`}
        >
            {col.cell !== undefined ?
                <span
                    onClick={handleClick}
                    className={`${active ? styles.active : ''} ${col.selectableCell ? styles.cell : ''}`}
                >
                    {col.cell(row)}
                </span>
                :
                <div
                    onClick={handleClick}
                    className={`${active ? styles.active : ''} ${col.selectableCell ? styles.cell : ''}`}
                >
                    {col.element?.(row)}
                </div>
            }
        </td>
    );
};

